import { useEffect, useState } from 'react';
import {
  Typography,
  Container,
  Box,
  Button,
  createMuiTheme,
  ThemeProvider,
} from '@mui/material';
import { styled, useTheme } from '@mui/system';
import { useTranslation } from 'react-i18next';

const ImageWarning = styled('img')(({ theme }) => ({
  width: theme.spacing(43),
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('xl')]: {
    width: theme.spacing(42),
  },
  [theme.breakpoints.down('lg')]: {
    width: theme.spacing(39),
  },
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(30),
  },
  [theme.breakpoints.down('sm')]: {},
}));

const LayoutStatusPageText = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode !== 'dark' ? 'rgba(0, 0, 0, 0.87)' : '#fff',
  textAlign: 'center',
  fontSize: `${theme.spacing(5)} !important`,
  lineHeight: 2,
  width: '80%',
  padding: `0 ${theme.spacing(2)}`,
  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(4.75)} !important`,
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(4.25)} !important`,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(3.5)} !important`,
  },
}));

const LayoutStatusPageTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.mode !== 'dark' ? 'rgba(0, 0, 0, 0.87)' : '#fff',
  padding: `0 ${theme.spacing(1.5)}`,
  fontSize: `${theme.spacing(12)} !important`,
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: theme.spacing(6.5),
  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(10)} !important`,
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(8)} !important`,
  },
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(6)} !important`,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: `${theme.spacing(5)} !important`,
  },
}));

const LayoutStatusPageBox = styled(Box)(({ theme }) => ({
  minHeight: '85vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  //   background: 'pink',
}));

const BackHomeButton = styled(Button)(({ theme }) => ({
  fontSize: `${theme.spacing(4)} !important`,
  padding: theme.spacing(3, 22),
  fontWeight: 600,
  color: theme.palette.mode !== 'dark' ? '#121212' : '#fff',
  textTransform: 'capitalize',
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.mode !== 'dark' ? '#121212' : '#fff'}`,
  boxShadow: '0px 0px 0px transparent',
  '&:hover': {
    // color: theme.palette.mode !== 'dark' ? '#121212' : '#fff',
    // backgroundColor: theme.palette.mode !== 'dark' ? '#121212' : '#fff',
    // border: '1px solid #121212',
  },
  [theme.breakpoints.down('xl')]: {
    fontSize: `${theme.spacing(3.75)} !important`,
    padding: theme.spacing(3, 21),
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: `${theme.spacing(3.5)} !important`,
    padding: theme.spacing(2.75, 20),
  },
  [theme.breakpoints.down('md')]: {
    fontSize: `${theme.spacing(3)} !important`,
    padding: theme.spacing(2, 18),
  },
  [theme.breakpoints.down('sm')]: {},
}));

const FallbackUI = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  function redirectToBaseDomain() {
    const url = window.location.href;
    const parsedUrl = new URL(url);
    const port = parsedUrl.port ? `:${parsedUrl.port}` : '';
    const baseDomain = `${parsedUrl.protocol}//${parsedUrl.hostname}${port}`;
    window.location.href = baseDomain;
  }

  return (
    <LayoutStatusPageBox>
      {/* <Container maxWidth="xl"> */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {theme.palette.mode !== 'dark' ? (
          <ImageWarning src={`/static/img/warning-2.svg`} />
        ) : (
          <ImageWarning src={`/static/img/warning-2-dark.svg`} />
        )}
        <LayoutStatusPageTitle>{t('fallback.title')}</LayoutStatusPageTitle>
        <LayoutStatusPageText>{t('fallback.subtitle')}</LayoutStatusPageText>
        <LayoutStatusPageText sx={{ mb: 10, mt: 2 }}>
          {t('fallback.text')}
        </LayoutStatusPageText>
        <BackHomeButton variant="outlined" onClick={redirectToBaseDomain}>
          Reload Page
        </BackHomeButton>
      </Box>
      {/* </Container> */}
    </LayoutStatusPageBox>
  );
};

export default FallbackUI;
